import { AgentsExpertPanelIcon, Icon, type IconProps } from '@grammarly/design-system'

type ExpertPanelAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const ExpertPanelAgentIcon = ({ size, accessibilityLabel }: ExpertPanelAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsExpertPanelIcon}
      accessibilityLabel={accessibilityLabel ?? 'Expert Review Agent'}
    />
  )
}
